import { LandStatusContainer } from '../../containers/advancedFilters/LandStatusContainer';
import { IFilter } from '../../types/advancedFilters';

export const landStatus: IFilter = {
  component: LandStatusContainer,
};
